class Shapes {
	constructor(x, y , w , h){
		this.x 	= x;
        this.y 	= y;
        this.w 	= w - 5;
        this.h	= h - 5;
        this.grad = {};
        this.padding = 5;
        this.nloop = 0;
        this.sizeText = 5;
        this.time_shape = 1000;
        this.is_active_shape = false;

	}

	// Método

	addShappe(context, star, color = 'grey' , text, is_static = false, timer = null){
		// console.log('addShappe');
		this.context 	= context;
		this.grad 		= this.context.createLinearGradient(
			this.x, 
            this.y, 
            this.x + this.w, 
            this.y + this.h
        );//0,200,200,0

		// start draw
		this.context.beginPath();
		
		// this.context.clearRect(this.x,this.y,this.w +5,this.h+5);
		
		
		// color 
		this.setColor(color);
		
		// color 
		this.context.fillStyle = this.grad;


		// shape
		this[star]();


		// close path
		this.context.fill();		// fill content
				// this.context.stroke(); // outlined
		// this.context.closePath();

		// set Text
		this.setTextShape(color, text)
		

		if (!is_static) {
			this.remove(null, star, timer);
		}
	}


	// Rombo
	normal(){
		//let tri = this.w / 5;

		

		// console.log(dx, dy, 'positions')
		this.context.moveTo(this.x + (this.w / 2), this.y);
	    this.context.lineTo(this.x + this.w, this.y + (this.h / 2 ));
	    this.context.lineTo(this.x + (this.w / 2), this.y + this.h); // + (tri * 2)
	    this.context.lineTo(this.x , this.y + (this.h / 2));

		// this.context.fillRect(0, 0, 200,200);
}
	// triangle
	warning(){
		// this.context.strokeStyle =		
	 	// grad = context.createLinearGradient(0,200,200,0);
	 	// let tri = this.w / 2;//* 0.4;
	 	console.log( this.x, this.y, this.w, this.h );
	 	/*this.context.closePath();
	 	;*/

	    this.context.moveTo(this.x + (this.w / 2) , this.y);
		console.log("this.x + (this.w / 2) , this.y", this.x + (this.w / 2) , this.y);

	    this.context.lineTo(this.x + this.w, this.y + this.h);
	    
		console.log("this.x + this.w, this.y + this.h)", this.x + this.w, this.y + this.h);
	    // this.context.lineTo(722 , 478);
	    this.context.lineTo(this.x, this.y + this.h);
	}


	// circle
	success(){
		

		
		// this.context.strokeStyle = " "
		this.context.arc(this.x + (this.w / 2),  // pos X
			this.y + (this.h/2) , 				// pos Y
			(this.w / 2)/2, 						// radius
			0, 									// start point on circle
			Math.PI * 3, 						// End point on circle
			false); 							// clockwise or anticlockwise
		// x, y, radius, startAngle, endAngle, anticlockwise)	

	}


	alert(){ 
		

		this.context.arc(
			this.x + (this.w / 2), 
			this.y + (this.h/2),
			(this.w / 2)/2, 
			0, 
			Math.PI * 2, 
			true);
	}

	setColor(color = 'grey'){

		if (color == 'grey') {
			this.grad.addColorStop(0, 'rgba(192,192,192,1)');
			this.grad.addColorStop(0.5, 'rgba(255,255,255,1)');
			this.grad.addColorStop(1, 'rgba(128,128,128,1)');
		}

		if (color == 'red') {
			this.grad.addColorStop(0.38, 'rgba(196,2,2,1)');
			this.grad.addColorStop(0.43, 'rgba(178,1,1,1)');
			this.grad.addColorStop(0.54, 'rgba(140,0,0,1)');
			this.grad.addColorStop(0.61, 'rgba(140,0,0,1)');
		}

		if ( color == 'green') {
			this.grad.addColorStop(0.39, 'rgba(5,163,39,1)');
			this.grad.addColorStop(0.54, 'rgba(5,163,39,1)');
			this.grad.addColorStop(0.86, 'rgba(213,249,19,1)');
			this.grad.addColorStop(0.88, 'rgba(227,255,18,1)');
		}

		if ( color == 'yellow' ) {
			this.grad.addColorStop(0.39, 'rgba(109,122,6,1)');
			this.grad.addColorStop(0.54, 'rgba(109,122,6,1)');
			this.grad.addColorStop(0.86, 'rgba(220,247,17,1)');
			this.grad.addColorStop(0.88, 'rgba(227,255,18,1)');
		}
	} 

	setTextShape(color, text){
		let coords 				= this.getDraw();
		// this.context.beginPath();
		this.context.font 		= "10px Georgia";
        this.context.fillStyle 	= "black";//"rgba(255,255,255, 0.9)";
        this.context.texAlign 	= "start"
        // console.log(text, coords, 'text positions')
        if (text) {
			this.context.fillText(
				text, 
				(coords.x - this.padding - this.sizeText) + (coords.w / 2), 
				coords.y + (coords.h / 2) ,[ coords.w ]
			);
        }

	}

	getDraw(){
        return {
            x:this.x,
            y:this.y,
            w:this.w,
            h:this.h
        };
    }
    getInsideStart() {
        let coords = this.getDraw();
        return [coords.x , coords.y , coords.w , coords.h ];
    }

	remove(n, shape, time = null){
        let vm = this;

        // vm[shape]();
        this.is_active_shape = true;
        const timer_shape = setTimeout(function () {
       		vm.context.clearRect(...vm.getInsideStart());                    
            vm.is_active_shape = false;
            clearTimeout(timer_shape);
          }, time ? time : vm.time_shape)


    }

    getIsActive(){
    	if (this.is_active_shape) {
    		return true
    	}
    	return false
    }

    setTimeShape(time = 500){
    	this.time_shape = time;
    }

}	

module.exports = Shapes;